import requests from "./httpService";

const UserServices = {
  createUser(userData) {
    return requests.post(`/api/users`, userData);
  },

  getAllUsers() {
    return requests.get(`/api/users`);
  },

  getUser(id) {
    return requests.get(`/api/users/${id}`);
  },

  updateUser(id, userData) {
    return requests.put(`/api/users/${id}`, userData);
  },

  deleteUser(id) {
    return requests.delete(`/api/users/${id}`);
  },

  updateProfile(userData) {
    return requests.put(`/api/users/profile/update`, userData);
  },
};

export default UserServices;
